import WeldNdtTestForm from './WeldNdtTestForm'
import { UT_METHOD_CONFIG } from '@/types/weldNdtTypes'

const UTTestForm = () => <WeldNdtTestForm config={UT_METHOD_CONFIG} />

export default UTTestForm
